export default __webpack_public_path__ + "static/media/icon_5.f91cbc8d.png";